import React, { useCallback, useMemo, useState } from 'react';
import { Icon } from 'ui';
import styled from 'styled-components';

const StyledIcon = styled(Icon)`
  color: rgba(0, 0, 0, 0.85);
  margin-left: auto;
`;

const Content = styled.div`
  display: ${p => p.isCollapsed ? 'none' : 'block'}
`;

const useCollapseExpand = (defaultCollapsed = false) => {
  const [isCollapsed, setIsCollapsed] = useState(defaultCollapsed);

  const arrow = useMemo(() =>
    <StyledIcon
      type={`chevron-${!isCollapsed ? 'up' : 'down'}`}
      onClick={() => setIsCollapsed(s => !s)}
    />,
    [isCollapsed]);

  const wrapper = useCallback(children =>
    <Content isCollapsed={isCollapsed}>{children}</Content>,
    [isCollapsed]);

  return [arrow, wrapper, isCollapsed, setIsCollapsed];
};

export default useCollapseExpand;
